import { apiClient } from "lib/apiClient";
import { IAssistantPage } from "api/getAssistantPages";
import { assistantPageCodeEnum } from "features/AssistantPages/constantTypes";

export const getAssistantPageById = async (
  pageCode: assistantPageCodeEnum
): Promise<IAssistantPage> => {
  const response = await apiClient.get(`/assistant/pages/${pageCode}`);

  return response.data;
};
